import styled from 'helpers/styles';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import Page from 'components/pages/Base/Page/Page';

const StyledErrorPage = styled(Page)`
  ${ComponentStyles}
`;

StyledErrorPage.propTypes = {
  theme: PropTypes.object
};

export default StyledErrorPage;
